import React from "react";
import Player from "./components/Player";
import RollDice from "./components/RollDice";
import 'bootstrap/dist/css/bootstrap.min.css';


function App(){
    return (
        <div className="App">
          
          <RollDice/>
        </div>
    )
}
export default App;